import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject, Observable } from 'rxjs';
import { CheckboxGridRow, CheckboxGridHeaderCell } from './checkbox-grid.model';

@Injectable()
export class CheckboxGridService {
  public headerCellObservableMap = {};

  rows: Observable<any>;

  rowsDataSource = new BehaviorSubject(Array<CheckboxGridRow>());
  public rowsDataStream = this.rowsDataSource.asObservable();

  updateCheckedStatus(column) {
    this.headerCellObservableMap[column.prop].behaviorSubject.next(column);
  }

  public populateHeaderCellObservableMap(
    headerCells: CheckboxGridHeaderCell[],
  ) {
    for (const cell of headerCells) {
      !this.headerCellObservableMap[cell.prop]
        ? this.createHeaderCellObservable(cell)
        : null;
    }
  }

  createHeaderCellObservable(cell) {
    this.headerCellObservableMap[cell.prop] = {
      behaviorSubject: new Subject(),
      bulkChecked: null,
    };

    this.headerCellObservableMap[cell.prop].observable =
      this.headerCellObservableMap[cell.prop].behaviorSubject.asObservable();
  }

  public initRowObservable(row) {
    this.rows = new Observable((observer) => {
      observer.next(row);
      observer.complete();
    });

    this.rows.subscribe(() => ({}));
  }

  setRows(rows) {
    this.rowsDataSource.next(rows);
  }
}
